import { render, staticRenderFns } from "./CheckTemperatura.vue?vue&type=template&id=6ee76c20&"
import script from "./CheckTemperatura.vue?vue&type=script&lang=ts&"
export * from "./CheckTemperatura.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports